import React from 'react'
import { makeStyles, Grid } from '@material-ui/core'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  type: {
    outline: '1px solid var(--color-neutral-700)',
    borderRadius: 'var(--border-radius-lg)',
    padding: theme.layout.padding.thick,
    fontSize: theme.typography.fontSizes.xxl,
    transition: 'outline .2s ease-in-out, background-color .2s ease-in-out',
    '&:hover': {
      backgroundColor: 'var(--color-neutral-500)',
      cursor: 'pointer'
    },
    '&.__selected': {
      outline: '2px solid var(--color-primary-500)',
      backgroundColor: 'color-mix(in srgb, var(--color-primary-300) 15%, transparent)',
      '&:hover': {
        outline: '2px solid var(--color-primary-500)'
      }
    },
    '& article': {
      fontWeight: theme.typography.weights.light
    }
  }
}))

const EnablementSelector = React.forwardRef(function EnablementSelector ({ value, onChange }, _) {
  const classes = useStyles()

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <div
          className={clsx(classes.type, { __selected: value === 'enabled' })}
          onClick={() => onChange('enabled')}
          role='button'
        >
          <header>Enabled</header>
          <article>
            <p>Users who are assigned this role will be authorized to use this integration.</p>
          </article>
        </div>
      </Grid>
      <Grid item xs={12}>
        <div
          className={clsx(classes.type, { __selected: value === 'disabled' })}
          onClick={() => onChange('disabled')}
          role='button'
        >
          <header>Disabled</header>
          <article>
            <p>Users who are assigned this role will <strong>not</strong> be authorized to use this integration.</p>
            <p>This doesn't stop the integration from being enabled on an individual user.</p>
          </article>
        </div>
      </Grid>
    </Grid>
  )
})

EnablementSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
}

export default EnablementSelector
